<template>
	<div
		class="layer"
		data-test="Layer-component"
	>
		<div
			class="layer-content"
			data-test="Layer-content"
		>
			<slot />
		</div>
	</div>
</template>
